'use client';

import { useMemo } from 'react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { topCategoriesQueryParams } from '@/constants/queryParams/newsQueryParams';
import { removeSpace } from '@/utils/removeSpace';

import { useEntityData } from '@/hooks/useEntityData';

export default function NewsNavbar() {
  const queryParams = useMemo(() => topCategoriesQueryParams, []);
  const { data: categoriesData }: any = useEntityData('categories', queryParams);

  const searchParams = useSearchParams();

  const categoryId = searchParams.get('category');

  const isActive = (categoryName: string) => {
    const categorySlug = removeSpace(categoryName);
    return categorySlug === categoryId;
  };

  return (
    <section>
      <div className="mb-7 px-2 lg:mb-10">
        <div className="relative flex items-center justify-center">
          <div className="relative flex h-8 w-full max-w-screen-md items-center rounded-full border border-primary-text-light pr-2 lg:h-12">
            <div className="hide-scrollbar flex w-full items-center gap-x-4 overflow-x-auto px-6 text-xs sm:text-lg">
              {/* Home Link */}
              <Link
                href="/news"
                className={`whitespace-nowrap font-inter text-sm capitalize ${
                  !categoryId ? 'text-primary underline decoration-blue-500 underline-offset-4' : 'text-gray-700'
                }`}
              >
                Home
              </Link>

              {/* Category Links */}
              {categoriesData?.data?.results?.map((tab: any) => {
                const categoryName = tab?.category_name;
                const categorySlug = removeSpace(categoryName);
                const updatedSearchParams = new URLSearchParams();
                updatedSearchParams.set('category', categorySlug);
                return (
                  <Link
                    key={categorySlug}
                    href={`/news?${updatedSearchParams.toString()}`}
                    className={`whitespace-nowrap font-inter text-sm capitalize ${
                      isActive(categoryName)
                        ? 'text-primary underline decoration-blue-500 underline-offset-4'
                        : 'text-gray-700'
                    }`}
                  >
                    {categoryName}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
